import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { columnDescription, columnName } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { deleteCollection, hideDeleteCollection } from '../actions';
import CollectionsTableColumns from './CollectionsTableColumns';
import CollectionsTableRows from '../components/CollectionsTableRows';

const CollectionDeletionDialog = ({
  deleteData,
  hide,
  results,
  theme,
}) => (
  <ActionDialogContent
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    items={results}
    hide={hide}
    theme={theme}
    onSubmit={deleteData}
    entity="collection"
    entities="collections"
    className="aridhia-collection-deletion-dialog"
    icon="sitemap"
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-collections-table">
        <Table.Header fullWidth>
          <CollectionsTableColumns items={results} columns={[columnName, columnDescription]} />
        </Table.Header>
        <Table.Body>
          <CollectionsTableRows items={results} columns={[columnName, columnDescription]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ActionDialogContent>
);

const mapStateToProps = ({
  collections: { collections: { deletion: { results } } },
}) => ({
  results,
});

const mapDispatchToProps = {
  hide: hideDeleteCollection,
  deleteData: deleteCollection,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDeletionDialog);
